import LocalStorageService from '../services/LocalStorageService'
import LoginService from '../services/LoginService'
import canGoTo from './can-go-to'

function originPath (path) {
  const originPath = path.match(/([/][^/]*)[/]?/)[1]

  return originPath
}

export default (to, from, next) => {
  const toLogin = (msg) => {
    LocalStorageService.setLoginMessage(msg)
    return next('/login')
  }
  const path = originPath(to.path)

  if (path === '/login') { return next() }

  if (!LocalStorageService.getAuthorization()) { return toLogin('Sessão expirada. Faça seu login') }

  LoginService.validateAuthorization()
    .then(({ status, data }) => {
      status === 200 && data === true ? tryGoToByUser() : toLogin('Sessão expirada. Faça seu login')
    })
    .catch(error => {
      console.error(error)
      toLogin('Ocorreu um erro ao validar a autorização')
    })

  function tryGoToByUser () {
    console.debug('Calling LOGIN - From Cache') // Continuar aqui - Se buscarmos do cache o Decorator falha*
    // const userDetails = LocalStorageService.getUserDetails()
    // canGoTo(path, userDetails) ? next() : toLogin('O usuário não possui permissão para acessar o conteúdo')

    LoginService.getUserDetails()
      .then(({ data: user }) => canGoTo(path, user) ? next() : toLogin('O usuário não possui permissão para acessar o conteúdo'))
      .catch(error => {
        console.error('error at tryGoToByUser', error)
        toLogin('O usuário não pôde ser identificado')
      })
  }
}
